import { STORAGE_KEYS } from '../redux/auth/authConstants';

const USER_INFO_KEY = 'userInfo';
const GUEST_ID_KEY = 'guestId';

// Guest ID Helpers - used for session tracking before login
export const getGuestId = () => {
  try {
    let guestId = localStorage.getItem(GUEST_ID_KEY);
    if (!guestId) {
      // Generate a simple UUID-like string with timestamp for uniqueness
      guestId = 'guest_' + Date.now() + '_' + Math.random().toString(36).substring(2, 15);
      localStorage.setItem(GUEST_ID_KEY, guestId);
    }
    return guestId;
  } catch (error) {
    console.error('Error with guestId:', error);
    return 'guest_fallback';
  }
};

export const setGuestId = (id) => {
  localStorage.setItem(GUEST_ID_KEY, id);
};

// Set tokens to storage
export const setToken = (accessToken, refreshToken, memberId) => {
  try {
    if (accessToken) {
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    }
    if (refreshToken) {
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
    }
    if (memberId) {
      localStorage.setItem(STORAGE_KEYS.MEMBER_ID, String(memberId));
    }
    console.log('[Auth] Tokens saved to localStorage:', { hasAccessToken: !!accessToken, hasRefreshToken: !!refreshToken, memberId });
    return true;
  } catch (error) {
    console.error('Error setting tokens:', error);
    return false;
  }
};

// Get access token from storage
export const getToken = () => {
  try {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  } catch (error) {
    console.error('Error getting token:', error);
    return null;
  }
};

// Get refresh token from storage
export const getRefreshToken = () => {
  try {
    return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
  } catch (error) {
    console.error('Error getting refresh token:', error);
    return null;
  }
};

// Get member ID from storage
export const getMemberId = () => {
  try {
    const memberId = localStorage.getItem(STORAGE_KEYS.MEMBER_ID);
    return memberId ? Number(memberId) : null;
  } catch (error) {
    console.error('Error getting member ID:', error);
    return null;
  }
};

// Remove all tokens from storage
export const removeToken = () => {
  try {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.MEMBER_ID);
    localStorage.removeItem(USER_INFO_KEY);
    localStorage.removeItem('businessType');
    sessionStorage.removeItem('pendingEmail');
    return true;
  } catch (error) {
    console.error('Error removing tokens:', error);
    return false;
  }
};

// Check if user has valid tokens
export const hasValidTokens = () => {
  const token = getToken();
  const refreshToken = getRefreshToken();
  const memberId = getMemberId();

  return !!(token && refreshToken && memberId);
};

// Get all auth data from storage
export const getAuthData = () => ({
  accessToken: getToken(),
  refreshToken: getRefreshToken(),
  memberId: getMemberId(),
});

// Set user info to storage
export const setUserInfo = (userInfo) => {
  try {
    if (userInfo) {
      localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
    }
    return true;
  } catch (error) {
    console.error('Error setting user info:', error);
    return false;
  }
};

// Get user info from storage
export const getUserInfo = () => {
  try {
    const userInfo = localStorage.getItem(USER_INFO_KEY);
    return userInfo ? JSON.parse(userInfo) : null;
  } catch (error) {
    console.error('Error getting user info:', error);
    return null;
  }
};

// Remove user info from storage
export const removeUserInfo = () => {
  try {
    localStorage.removeItem(USER_INFO_KEY);
    return true;
  } catch (error) {
    console.error('Error removing user info:', error);
    return false;
  }
};
